<div class="diaContainer">
    <h2 mat-dialog-title>Add Options</h2>
    <p>(Min:2 Max:10)</p>
    <p *ngIf="dupOpts" style="font-weight: bolder;">Please remove the duplicate options
      <span title="Duplicate options warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
    <div class="optDialog" *ngFor="let opt of optArr">
        <p>{{opt}}</p>
        
        <div class="optDialog">
          <owc-icon (click)="removeOpt(opt)" name="circle_remove" family=""></owc-icon>
          <owc-icon (click)="editOpt(opt)" name="write" family=""></owc-icon>
        </div>
    </div>

    <div class="optDialog">
        <div class="input-with-options">
          <owc-input 
            type="text" *ngIf="fieldFlag" [(ngModel)]="opts" placeholder="Add Option" [maxlength]="charLimit" class="text-input">
          </owc-input>
        </div>
        
        <div class="optDialog">
            <owc-icon (click)="addOpt()" *ngIf="!disableFlag" [title]="'Add'" name="circle_add" family=""></owc-icon>
            <owc-icon (click)="updateOpt(opts)" *ngIf="updateFlag" [title]="'Update'" name="history" family=""></owc-icon>
        </div>
    </div>

    <div style="margin-top:10px">
      <owc-button color="primary" style="float:right" (click)="onConfirm()" [disabled]="!isConfirm || dupOpts">Confirm</owc-button>
      <owc-button class="cancel-button" (click)="onCancel()">Cancel</owc-button>
    </div>
</div>
